<template>
    <div>
        <rkm-area
            background-color="secondary"
            title="Desfecho"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-radio-group
                        :validations="validations.finalizado"
                        @change="handleDesfechoChange"
                        class="mt-1 mb-2"
                        name="Desfecho"
                        v-model="data.model.desfecho.finalizado"
                    >
                        <rkm-form-radio :value="true">Liberar paciente</rkm-form-radio>
                        <rkm-form-radio :value="false">Manter/encaminhar no mesmo setor</rkm-form-radio>
                        <rkm-form-radio
                            v-if="!isRetroativo"
                            :value="'encaminhar'"
                        >
                            Encaminhar para outro setor
                        </rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <template v-if="data.model.desfecho.finalizado && data.model.desfecho.finalizado != 'encaminhar'">
                <rkm-row v-if="data.additionals.protocoloFechamento && !!data.additionals.protocoloFechamento.controlaProtocoloFechamento">
                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.protocoloFechamento"
                            @change="handleProtocoloFechamentoChange"
                            label="Protocolo de fechamento"
                            v-model="data.model.desfecho.protocoloFechamento"
                        />
                    </rkm-col>
                </rkm-row>
            </template>

            <rkm-row v-if="data.model.desfecho.finalizado === 'encaminhar'">
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.desfecho.centrosCustoEncaminhamento"
                        :validations="validations.centroCustoEncaminhamento"
                        label="Setor de Encaminhamento"
                        show-default-option
                        text-field="setorNome"
                        v-model="data.model.desfecho.centroCustoEncaminhamentoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col
                    v-if="isSetorEncaminhamentoEnfermagem"
                    cols="auto"
                >
                    <rkm-form-checkbox
                        :label="false"
                        @change="handlePosCosultaChange"
                        v-model="data.model.desfecho.posConsulta"
                    >
                        Pós-consulta
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>

            <template v-if="data.model.desfecho.finalizado == false || data.model.desfecho.finalizado == 'encaminhar'">
                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            :disabled="demandaEspontaneaObservaVagaAtendimento"
                            :options="data.form.desfecho.usuarios"
                            @change="handleUsuarioChange"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="demandaEspontaneaObservaVagaAtendimento"
                            :options="data.form.desfecho.ocupacoes"
                            @change="handleOcupacaoChange"
                            label="CBO"
                            show-default-option
                            text-field="descricao"
                            v-model="data.model.desfecho.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="demandaEspontaneaObservaVagaAtendimento"
                            :options="data.form.desfecho.especialidades"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col v-if="demandaEspontaneaObservaVagaAtendimento">
                        <rkm-form-select
                            :options="data.form.desfecho.jornadas"
                            disabled
                            label="Jornada"
                            show-default-option
                            text-field="descricao"
                            v-model="data.model.desfecho.jornadaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row v-if="data.form.desfecho.servicos.length > 0">
                    <rkm-col>
                        <rkm-form-checkbox-group
                            :options="data.form.desfecho.servicos"
                            label="Serviços"
                            text-field="nome"
                            v-model="data.model.desfecho.servicos"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row v-if="!isRetroativo">
                    <rkm-col>
                        <rkm-form-select
                            :options="data.form.desfecho.opcoesEntrada"
                            :validations="validations.opcaoEntrada"
                            disabled
                            label="Opção de entrada"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.opcaoEntradaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :options="data.form.desfecho.prioridades"
                            :validations="validations.prioridade"
                            label="Prioridade"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.prioridadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'
import servicoTipo from '@/enums/ambulatorio/servicoTipo'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                finalizado: {required: true},
                protocoloFechamento: {required: true},
                prioridade: {
                    required:
                        !!this.data.model.opcaoEntradaId &&
                        this.data.form.opcoesEntrada.find(opcaoEntrada => opcaoEntrada.id === this.data.model.opcaoEntradaId).prioridadeObrigatoria
                },
                centroCustoEncaminhamento: {required: true},
            }
        },
        isRetroativo() {
            return this.filaId === 0
        },
        isSetorEncaminhamentoEnfermagem() {
            if (!this.data.model.desfecho.centroCustoEncaminhamentoId) {
                return false
            }

            return this.data.form.desfecho.centrosCustoEncaminhamento
                .find(cc => cc.id === this.data.model.desfecho.centroCustoEncaminhamentoId)
                .setorTipoId === this.enums.setorTipo.ENFERMAGEM
        },
        demandaEspontaneaObservaVagaAtendimento() {
            return this.data.form.desfecho.especialidades.find(especialidade => especialidade.id === this.data.model.desfecho.especialidadeId)?.demandaEspontaneaObservaVagaAtendimento === true
        },
    },
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
        }
    },
    data: () => ({
        enums: {setorTipo, servicoTipo},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleDesfechoChange() {
            this.data.model.desfecho.protocoloFechamento = null

            if (this.demandaEspontaneaObservaVagaAtendimento === false) {
                this.data.model.desfecho.usuarioId = null
                this.data.model.desfecho.ocupacaoId = null
                this.data.model.desfecho.especialidadeId = null
            }
        },
        handleProtocoloFechamentoChange(value) {
            if (this.data.additionals.protocoloFechamento.numero !== value) {
                this.showValidationNotification('O protocolo de fechamento informado é inválido.')
                this.data.model.desfecho.protocoloFechamento = null
            }
        },
        handleUsuarioChange(value) {
            this.data.form.desfecho.ocupacoes = []
            this.data.form.desfecho.especialidades = []
            this.data.model.desfecho.ocupacaoId = null
            this.data.model.desfecho.especialidadeId = null

            if (value === null) return

            this.getOcupacoes(value)
        },
        handleOcupacaoChange(value) {
            this.data.form.desfecho.especialidades = []
            this.data.model.desfecho.especialidadeId = null

            if (value === null) return

            this.getEspecialidades(this.data.model.desfecho.usuarioId, value)
        },
        getOcupacoes(usuarioId) {
            const request = {
                origem: 'desfecho',
                listar: 'ocupacoes',
                filaId: this.filaId,
                usuarioId,
            }

            this.setLoading()

            this.repositories.atendimento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.desfecho.ocupacoes = Object.assign(response.data.ocupacoes)

                    if (this.data.form.desfecho.ocupacoes.length === 1) {
                        const ocupacaoId = this.data.form.desfecho.ocupacoes[0].id

                        this.data.model.desfecho.ocupacaoId = ocupacaoId

                        this.getEspecialidades(this.data.model.desfecho.usuarioId, ocupacaoId)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEspecialidades(usuarioId, ocupacaoId) {
            const request = {
                origem: 'desfecho',
                listar: 'especialidades',
                filaId: this.filaId,
                usuarioId,
                ocupacaoId,
            }

            this.setLoading()

            this.repositories.atendimento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.desfecho.especialidades = Object.assign(response.data.especialidades)

                    if (this.data.form.desfecho.especialidades.length === 1) {
                        this.data.model.desfecho.especialidadeId = this.data.form.desfecho.especialidades[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handlePosCosultaChange(checked) {
            if (checked) {
                this.checkServicosPosConsulta()
            }
            else {
                this.uncheckServicosPosConsulta()
            }
        },
        checkServicosPosConsulta() {
            this.data.form.desfecho.servicos
                .filter(s => s.tipoId === this.enums.servicoTipo.POS_CONSULTA && !this.data.model.desfecho.servicos.includes(s.id))
                .forEach(s => this.data.model.desfecho.servicos.push(s.id))
        },
        uncheckServicosPosConsulta() {
            this.data.form.desfecho.servicos
                .filter(s => s.tipoId === this.enums.servicoTipo.POS_CONSULTA && this.data.model.desfecho.servicos.includes(s.id))
                .forEach(s => this.data.model.desfecho.servicos.splice(this.data.model.desfecho.servicos.indexOf(s.id), 1))
        }
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
        filaId: {type: Number, required: true},
    },
    watch: {
        isSetorEncaminhamentoEnfermagem(isSetorEncaminhamentoEnfermagem) {
            if (isSetorEncaminhamentoEnfermagem) {
                if (this.data.model.desfecho.posConsulta) {
                    this.checkServicosPosConsulta()
                }
            }
            else {
                this.uncheckServicosPosConsulta()
            }
        }
    }
}
</script>